import PublicDashboard from './PublicDashboard';

export const KeenPublicDashboard = PublicDashboard;
